import { Users } from "lucide-react";

const ComingSoonPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <Users className="w-16 h-16 text-gray-400 mx-auto mb-4" />
        <h1 className="text-2xl font-semibold text-gray-700">Customer List</h1>
        <p className="mt-2 text-gray-500">
          We're working hard to bring this feature to you. Stay tuned!
        </p>
        <div className="mt-6">
          <button
            onClick={() => window.history.back()}
            className="px-4 py-2 text-sm font-medium text-blue-600 bg-blue-100 rounded-md hover:bg-blue-200 transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
